module.exports = __webpack_public_path__ + "img/company-form.a34a3400.svg";